import { render, staticRenderFns } from "./OrderFakeCmp.vue?vue&type=template&id=ab506be4&"
import script from "./OrderFakeCmp.vue?vue&type=script&lang=js&"
export * from "./OrderFakeCmp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports